function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 16.167h4.167l-1.17-1.171A1.693 1.693 0 0117 13.799v-2.632a5.002 5.002 0 00-3.333-4.716v-.284a1.667 1.667 0 10-3.333 0v.284A5.002 5.002 0 007 11.167v2.632c0 .449-.178.88-.496 1.197l-1.17 1.17H9.5m5 0V17a2.5 2.5 0 01-5 0v-.833m5 0h-5",
  stroke: "#FF6C0E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.667 8.333a3.333 3.333 0 11-6.667 0 3.333 3.333 0 016.667 0z",
  fill: "#0098FF"
});

function SvgBellStaticNotif(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/bell_static_notif.svg";
export { SvgBellStaticNotif as ReactComponent };